module.exports = __webpack_public_path__ + "static/media/check_gray.54244469.svg";